import React from 'react';
import { Translate as t } from '../../config/Translate';

// 일괄 가져오기(20건 청크 반복) 화면 공용 결과 요약.
// 집계는 화면이 이미 가진 값(청크 처리 성공 누적 건수, 실패한 청크의 일련번호)만 쓴다.
// 서버가 레코드 단위 skipped 를 주지 않으므로 skipped 는 만들지 않는다.
const MAX_SHOWN_SNS = 20;

// 청크 항목이 문자열(sn)이든 { sn } 객체든 일련번호만 꺼낸다.
export const getChunkSerials = (chunk) => {
	if (!Array.isArray(chunk)) return [];
	return chunk
		.map(x => (typeof x === 'string' ? x : x?.sn))
		.filter(x => x !== undefined && x !== null && x !== '');
};

// 요약 객체 조립: total=전체 건수, applied=성공한 청크 누적, failedChunk=실패한 청크(없으면 완료)
export const buildImportSummary = (total, applied, failedChunk) => ({
	total: Number(total) || 0,
	applied: Number(applied) || 0,
	failedCount: Array.isArray(failedChunk) ? failedChunk.length : 0,
	failedSns: getChunkSerials(failedChunk),
});

const ImportResultSummary = ({ summary }) => {
	if (!summary) return null;
	const total = Number(summary.total) || 0;
	const applied = Number(summary.applied) || 0;
	const failedCount = Number(summary.failedCount) || 0;
	const failedSns = Array.isArray(summary.failedSns) ? summary.failedSns : [];
	const notProcessed = Math.max(total - applied - failedCount, 0);
	const shown = failedSns.slice(0, MAX_SHOWN_SNS);
	const hidden = failedSns.length - shown.length;

	return (
		<div className="mt-2 text-start" data-testid="import-result-summary" role="status">
			<ul className="list-unstyled mb-1">
				<li>{t('product.import.summary.total')}: {total}</li>
				<li>{t('product.import.summary.applied')}: {applied}</li>
				<li className={failedCount > 0 ? 'text-danger' : ''}>{t('product.import.summary.failed')}: {failedCount}</li>
				<li>{t('product.import.summary.notProcessed')}: {notProcessed}</li>
			</ul>
			{failedCount > 0 && <div className="small">
				<div>{t('product.import.summary.failedSns')}: {shown.join(', ')}{hidden > 0 ? ` +${hidden}` : ''}</div>
				<div className="text-muted">{t('product.import.summary.failedNote')}</div>
			</div>}
		</div>
	);
};

export default ImportResultSummary;
